import React from 'react';
import { ComposedChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import DashboardCard, {
    ChartBody,
    ChartEmpty,
    ChartPlot,
    ChartTooltip,
    CHART_MARGIN,
    chartTick,
    formatChartCurrency,
} from './DashboardCard';

interface SalesByMonthChartProps {
    data: any[];
}

/** Compacto o bastante para não cortar no eixo — dado em DM Mono. */
const formatAxisValue = (val: number) => {
    if (!Number.isFinite(val) || val === 0) return '0';
    if (val >= 1_000_000) {
        return `${(val / 1_000_000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}M`;
    }
    if (val >= 1000) return `${Math.round(val / 1000)}k`;
    return String(Math.round(val));
};

/** Meses — mesma face da legenda (DM Sans / text-sm / muted). */
const monthTick = {
    fill: 'var(--color-text-muted)',
    fontSize: 12.5,
    fontWeight: 400,
    fontFamily: 'var(--font-sans)',
} as const;

const SalesByMonthChart: React.FC<SalesByMonthChartProps> = ({ data }) => {
    return (
        <DashboardCard title="Vendas nos últimos meses">
            {data.length === 0 ? (
                <ChartEmpty>Sem vendas neste período.</ChartEmpty>
            ) : (
                <ChartBody>
                    <ChartPlot>
                            <ComposedChart data={data} margin={CHART_MARGIN}>
                                <CartesianGrid
                                    stroke="var(--color-border-subtle)"
                                    vertical={false}
                                    strokeDasharray="0"
                                />
                                <XAxis
                                    dataKey="name"
                                    tick={monthTick}
                                    tickLine={false}
                                    axisLine={false}
                                    interval={0}
                                    minTickGap={8}
                                    tickMargin={10}
                                />
                                <YAxis
                                    type="number"
                                    tick={chartTick}
                                    tickLine={false}
                                    axisLine={false}
                                    width={44}
                                    tickCount={4}
                                    tickMargin={8}
                                    tickFormatter={formatAxisValue}
                                />
                                <Tooltip
                                    cursor={{ fill: 'var(--color-surface-subtle)' }}
                                    content={<ChartTooltip formatValue={formatChartCurrency} />}
                                />
                                <Bar dataKey="value" name="Vendas" fill="var(--color-success)" radius={[6, 6, 0, 0]} barSize={18} />
                                <Bar dataKey="negotiation" name="Em Negociação" fill="var(--color-primary)" radius={[6, 6, 0, 0]} barSize={18} />
                            </ComposedChart>
                    </ChartPlot>
                    <ul className="flex flex-wrap justify-center gap-s3 pt-s3">
                        <li className="flex items-center gap-s1">
                            <span className="size-2 shrink-0 rounded-full bg-success" />
                            <span className="text-sm text-muted">Vendas</span>
                        </li>
                        <li className="flex items-center gap-s1">
                            <span className="size-2 shrink-0 rounded-full bg-primary" />
                            <span className="text-sm text-muted">Em negociação</span>
                        </li>
                    </ul>
                </ChartBody>
            )}
        </DashboardCard>
    );
};

export default SalesByMonthChart;
